<!-- /* [MP-MATCH-SEND-TAB] 나의 매칭현황 - 보낸 신청서 */ -->

<template>
  <div>
    <section>
      <h1 class="matchingTitle">
        나의 매칭 현황
      </h1>
      <div class="inner row3_1 flex mobileFlexCol">
        <article class="wd100">
          <MatchingProcess />
          <article class="aRow2 directMatching">
            <div style="display: flex; align-items: center; gap: 4px;">
              <span
                class="btn-router"
                :class="{ 'router-link-active': isReceived }"
                @click="handleChangeTab(true)"
              >
                받은 신청서
              </span>

              <span
                class="btn-router"
                :class="{ 'router-link-active': !isReceived }"
                @click="handleChangeTab(false)"
              >
                보낸 신청서
              </span>
            </div>

            <div class="selectOption" style="margin-bottom: 4px;">
              <SelectOption
                v-model="params.status"
                :options="options"
                width="200px"
                height="40px"
                :handleChangeOption="onChangeStatus"
              />
            </div>
          </article>

          <div class="napaLists" style="margin-top: 24px;">
            <div v-for="(item, i) in items" :key="i">
              <ItemReceived
                v-if="isReceived"
                :data="item"
                :handleClickItem="handleClickReceiveItem"
                :handleClickItemButtonDelete="handleRemoveDirect"
              />
              <ItemSent
                v-else
                :data="item"
                @onReload="sentList"
                @clickView="handleClickSentItem"
              />
            </div>
            <PaginationMatching
              :rows="matchingList.length"
              :page.sync="page"
              :perPage="itemPerPage"
            />
          </div>
        </article>
      </div>
    </section>
    <MatchingReceivePopups @removeItem="receivedList" />
    <MatchingSentPopups />
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import SelectOption from "@/components/formControl/SelectOption.vue";
import MatchingProcess from "@/components/items/MatchingProcess.vue";
import ItemSent from "@/components/matching/ItemSent.vue";
import ItemReceived from "@/components/matching/ItemReceived.vue";
import MatchingReceivePopups from "@/components/matching/popup/MatchingReceivePopups.vue";
import MatchingSentPopups from "@/components/matching/popup/MatchingSentPopups.vue";
import PaginationMatching from "@/components/general/PaginationMatching.vue";
import {
  directStatus,
  napStatus,
  matchingStatusOptions,
  keyStorage,
} from "@/data/constances";

export default {
  name: "MyMatching",
  components: {
    SelectOption,
    MatchingProcess,
    ItemSent,
    ItemReceived,
    MatchingReceivePopups,
    PaginationMatching,
    MatchingSentPopups,
  },
  computed: {
    ...mapState("directMatching", ["selectedDirectMatching"]),
    ...mapState("matching", ["matchingList"]),
    items() {
      return this.lodash.slice(
        this.matchingList,
        (this.page - 1) * this.itemPerPage,
        this.page * this.itemPerPage,
      );
    },
  },
  data() {
    return {
      user: this.$store.state.auth.user,
      isReceived: true,
      options: matchingStatusOptions,
      params: {
        status: "",
      },
      page: 1,
      itemPerPage: 6,
    };
  },
  mounted() {
    this.receivedList();
  },
  methods: {
    ...mapActions("matching", ["loadSentMatching", "loadReceivedMatching"]),
    ...mapMutations("directMatching", ["setSelectedDirectMatching"]),
    handleChangeTab(tabActive) {
      if (this.isReceived === tabActive) return;
      this.isReceived = tabActive;
      if (tabActive) {
        this.receivedList();
      } else {
        this.sentList();
      }
    },
    onChangeStatus() {
      localStorage.setItem(keyStorage.matchingStatus, this.params.status);
      if (this.isReceived) this.receivedList();
      else this.sentList();
    },
    receivedList() {
      this.loadReceivedMatching({
        requestedIdx: this.$store.state.auth.user.idx,
        status: this.params.status,
      });
    },
    sentList() {
      // if (this.lodash.isEmpty(this.params.status)) {
      //   this.params.status = napStatus.PENDING;
      // }
      this.loadSentMatching({
        requesterIdx: this.$store.state.auth.user.idx,
        status: this.params.status,
      });
    },
    handleUpdatePartialDirectPopup(data) {
      this.directPopup = {
        ...this.directPopup,
        ...data,
      };
    },

    async handleClickReceiveItem(item) {
      this.setSelectedDirectMatching(item);
      switch (item.status) {
        case directStatus.PENDING:
          this.$store.commit(
            "directMatching/setOpenModalPopup",
            "matchReadPopup",
          );
          return;
        case directStatus.APPROVED:
          this.$store.commit(
            "directMatching/setOpenModalPopup",
            "receiveAcceptPopup",
          );
          return;
        case directStatus.REJECT:
          this.$store.commit(
            "directMatching/setOpenModalPopup",
            "receiveDenyPopup",
          );
          return;
      }
    },

    async handleClickSentItem(item) {
      this.setSelectedDirectMatching(item);

      switch (item.isNap) {
        case true:
          switch (item.status) {
            case napStatus.PENDING:
              this.$store.commit(
                "directMatching/setOpenModalPopup",
                "matchNapPopup",
              );
              return;
            case napStatus.APPROVED:
              this.$store.commit(
                "directMatching/setOpenModalPopup",
                "answerNapPopup",
              );
              return;
          }
          break;
        case false:
          switch (item.status) {
            case directStatus.PENDING:
              this.$store.commit(
                "directMatching/setOpenModalPopup",
                "matchReadPopup",
              );
              return;
            case directStatus.APPROVED:
              this.$store.commit(
                "directMatching/setOpenModalPopup",
                "receiveAcceptPopup",
              );
              return;
            case directStatus.REJECT:
              this.$store.commit(
                "directMatching/setOpenModalPopup",
                "receiveDenyPopup",
              );
              return;
          }
          break;
      }
    },

    handleRemoveDirect(item) {
      this.setSelectedDirectMatching(item);
      this.$store.commit("directMatching/setOpenModalPopup", "deletePopup");
    },
  },
};
</script>

<style lang="scss" scoped>
// section 2
.directMatching {
  display: flex;
  border-bottom: 1px solid #d6d6d6;
  justify-content: space-between;
}
</style>
